export default {
  type: "Feature",
  properties: {
    name: "Цэцэрлэг",
    location: [47.35202050047125, 100.74114060620876],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [98.41651439666748, 47.61481374692148],
        [98.32489013671875, 47.63023101663225],
        [98.25347900390624, 47.65428791076272],
        [98.19305419921875, 47.706065135695745],
        [98.17108154296875, 47.787325537803106],
        [98.2012939453125, 47.85187391101592],
        [98.20678710937499, 47.91450120703987],
        [98.18756103515625, 47.98440682947526],
        [98.2232666015625, 48.056053763981225],
        [98.27545166015625, 48.09459164290992],
        [98.35784912109375, 48.10559716402152],
        [98.4814453125, 48.100094697973795],
        [98.54736328125, 48.111099041065366],
        [98.6627197265625, 48.16608541901253],
        [98.7066650390625, 48.206371336358906],
        [98.8385009765625, 48.23747967660676],
        [98.953857421875, 48.27588152743497],
        [99.0743637084961, 48.296099474919146],
        [99.07432079315186, 48.29617085179661],
        [99.1680908203125, 48.26674084583965],
        [99.22027587890624, 48.24571107288924],
        [99.26422119140625, 48.23565029755306],
        [99.35760498046875, 48.2420528380672],
        [99.61166381835938, 48.274967532852976],
        [99.70230102539062, 48.295985271707664],
        [99.744873046875, 48.339820521006125],
        [99.7833251953125, 48.420998730129426],
        [99.78607177734375, 48.486576276944774],
        [99.9041748046875, 48.463815894066066],
        [99.96185302734375, 48.44377831058805],
        [100.0469970703125, 48.40550278187468],
        [100.107421875, 48.38909015961602],
        [100.17196655273438, 48.390002110874164],
        [100.21041870117186, 48.412795581099964],
        [100.2117919921875, 48.45561965661709],
        [100.22552490234374, 48.4765629664158],
        [100.28182983398438, 48.4902169906863],
        [100.37796020507812, 48.4965876108066],
        [100.47546386718749, 48.50932644976633],
        [100.39581298828125, 48.58205840283824],
        [100.36148071289062, 48.629278127969414],
        [100.35736083984375, 48.675546901341384],
        [100.38619995117188, 48.75075629617738],
        [100.4315185546875, 48.823140892101684],
        [100.48095703125, 48.866521538507754],
        [100.579833984375, 48.89271247049609],
        [100.64163208007812, 48.923401616679705],
        [100.60317993164062, 48.95948236523749],
        [100.47683715820312, 48.9991410647952],
        [100.535888671875, 49.034266715880854],
        [100.64437866210938, 49.10444366870733],
        [100.70205688476562, 49.20503726723141],
        [100.88607788085938, 49.13095912169914],
        [100.94856262207031, 49.116130191506805],
        [101.14837646484375, 49.050920216584856],
        [101.28021240234375, 49.015355983769666],
        [101.36054992675781, 48.96939999849952],
        [101.44912719726561, 48.95407191575548],
        [101.53770446777344, 48.950915549215985],
        [101.60568237304686, 48.95948236523749],
        [101.66610717773438, 48.963089005540155],
        [101.66559219360352, 48.963089005540155],
        [101.74713134765625, 48.89000369970676],
        [101.81304931640625, 48.866521538507754],
        [101.876220703125, 48.86290791986464],
        [101.93389892578125, 48.832181625698475],
        [101.9586181640625, 48.77429274267509],
        [102.03826904296875, 48.77248263837077],
        [102.12890625, 48.81048112472012],
        [102.2003173828125, 48.6746400785837],
        [102.2332763671875, 48.494767515307295],
        [102.2772216796875, 48.44742209577057],
        [102.337646484375, 48.42191010942875],
        [102.37060546875, 48.32703913063476],
        [102.48596191406249, 48.25759852914997],
        [102.6287841796875, 48.25394114463431],
        [102.755126953125, 48.1367666796927],
        [102.83752441406249, 48.02299832104887],
        [102.843017578125, 47.90529605906089],
        [103.0133056640625, 47.83528342275264],
        [103.084716796875, 47.724544549099676],
        [103.1890869140625, 47.71345768748889],
        [103.4088134765625, 47.47637579720936],
        [103.6669921875, 47.331377157798244],
        [103.67729187011719, 47.250805241535076],
        [103.67729187011719, 47.250805241535076],
        [103.63746643066406, 47.219101747038245],
        [103.59214782714844, 47.201843347946806],
        [103.52073669433594, 47.18737928434322],
        [103.44589233398436, 47.18457933279251],
        [103.34701538085938, 47.18737928434322],
        [103.1890869140625, 47.204642388766935],
        [103.13690185546875, 47.23262467463881],
        [103.03802490234375, 47.31275872224939],
        [102.952880859375, 47.32579231609051],
        [102.886962890625, 47.357431944587034],
        [102.843017578125, 47.37231462056695],
        [102.755126953125, 47.37975438400816],
        [102.71392822265625, 47.41322033016902],
        [102.68096923828124, 47.40764414848437],
        [102.65075683593749, 47.39091206104779],
        [102.6397705078125, 47.366734109127115],
        [102.65350341796875, 47.333238640473475],
        [102.68783569335938, 47.30903424774781],
        [102.72079467773436, 47.28202395793543],
        [102.72628784179688, 47.25779610603277],
        [102.72628784179688, 47.23915174981453],
        [102.68783569335938, 47.18877920473518],
        [102.64251708984374, 47.15517092451596],
        [102.58621215820312, 47.12901644660399],
        [102.557373046875, 47.080409706315635],
        [102.54226684570312, 47.00179736417431],
        [102.51205444335938, 46.953074529521054],
        [102.46536254882812, 46.930572093016316],
        [102.40493774414062, 46.95776134668866],
        [102.32940673828125, 47.01116205043071],
        [102.29644775390625, 47.02614213366051],
        [102.26486206054688, 47.02614213366051],
        [102.14263916015625, 47.01116205043071],
        [102.09869384765625, 46.99524110694596],
        [102.00256347656249, 46.98118927533914],
        [101.92291259765625, 46.961510504873075],
        [101.87759399414062, 46.92963428624288],
        [101.84738159179686, 46.88460024993555],
        [101.81991577148438, 46.87239702052007],
        [101.77047729492188, 46.862069043222895],
        [101.62628173828125, 46.85173907873366],
        [101.41342163085938, 46.84798223530896],
        [101.28849506378174, 46.826199106709744],
        [101.28849506378174, 46.82616974343502],
        [101.26012802124023, 46.82367380645847],
        [101.22905731201172, 46.827197448507164],
        [101.20536804199219, 46.836240405913],
        [101.17652893066405, 46.850330293243495],
        [101.12091064453125, 46.83389173208538],
        [101.06666564941406, 46.82637528602131],
        [100.99113464355469, 46.82637528602131],
        [100.86685180664062, 46.83905867900795],
        [100.75561523437499, 46.830133640447386],
        [100.69381713867186, 46.83717984670198],
        [100.67459106445312, 46.86582490125156],
        [100.60729980468749, 46.931040990245364],
        [100.55992126464844, 46.95213711682888],
        [100.46859741210938, 46.97181933529799],
        [100.43838500976562, 47.00273390667881],
        [100.43426513671875, 47.041118014219414],
        [100.42053222656249, 47.089760603235646],
        [100.447998046875, 47.184112659842015],
        [100.23239135742188, 47.140227084105625],
        [100.0799560546875, 47.11219605898181],
        [99.942626953125, 47.05889641405164],
        [99.920654296875, 47.121541375281744],
        [99.91928100585938, 47.19251214527278],
        [99.90005493164062, 47.25593196573788],
        [99.89456176757812, 47.35650163792198],
        [99.86572265625, 47.408573553097554],
        [99.76821899414062, 47.4921528170241],
        [99.75723266601561, 47.53018378265907],
        [99.75860595703125, 47.619124098197325],
        [99.7174072265625, 47.62004976487241],
        [99.66110229492188, 47.60153331738691],
        [99.46884155273436, 47.5774521343697],
        [99.40567016601562, 47.5561403129434],
        [99.3768310546875, 47.517200697839414],
        [99.33837890625, 47.489368981370724],
        [99.26696777343749, 47.46152250874388],
        [99.21203613281249, 47.454094290400015],
        [99.05685424804688, 47.454094290400015],
        [98.97171020507812, 47.47266286861342],
        [98.93463134765625, 47.50421439972969],
        [98.83575439453125, 47.55521351530769],
        [98.800048828125, 47.646886969413],
        [98.79043579101562, 47.72362073407563],
        [98.55697631835936, 47.69682297134991],
        [98.48281860351562, 47.667237034505156],
        [98.4166431427002, 47.614958395343585],
        [98.41651439666748, 47.61481374692148],
      ],
    ],
  },
};
